import { useSelector } from 'react-redux';
import { WholeState } from '../../../store/common/type';
import { handleImageUrl } from './imageUrlHelper';

export interface SharpieImageConfig {
  desktop: {
    width: number;
    height: number;
  };
  smallDesktop?: {
    width: number;
    height: number;
  };
  tablet: {
    width: number;
    height: number;
  };
  mobile: {
    width: number;
    height: number;
  };
}

export type SharpieOption = 'crop' | 'fit';

export function useSharpie(
  imageUrl: string,
  imageConfig: SharpieImageConfig,
  option = 'crop' as SharpieOption,
): string {
  const deviceType =
    useSelector((state: WholeState) => state.common.deviceType) ?? 'desktop';

  const isNextGenSupported = useSelector(
    (state: WholeState) => state.common.isNextGenSupported,
  );

  return handleImageUrl(
    imageUrl,
    imageConfig[deviceType]?.width,
    imageConfig[deviceType]?.height,
    isNextGenSupported,
    option,
  );
}
